module.exports = __webpack_public_path__ + "static/media/DAI-ETH SLP-logo.f0bb5e8a.png";